import React, { Component } from "react";
import LocaleReceiver from 'antd/es/locale-provider/LocaleReceiver';
import defaultLocale from '../locale/default';

interface IOProps {
  id: string
  playerProps: object
  callBack: any,
  local:any
}
class Video extends Component<IOProps> {
  creatVideo = () => {
    const { playerProps, callBack, local} = this.props;
    const player = new (window as any).Aliplayer({
      ...playerProps,
      language: local.name,
      languageTexts: {
        [local.name]: local.content
      }
     }, function () {
        callBack(player)
    });
  }

  componentDidMount(){
    this.creatVideo()
  }

  render () {
    return <div id={this.props.id}></div>
  }
}

function VideoPlayer(props: IOProps) {
  const { id, playerProps, callBack } = props;
  return(
    <LocaleReceiver componentName="VideoPlayer" defaultLocale={defaultLocale.VideoPlayer}>
      {(locale) => {
          return (
            <Video id={id} playerProps={playerProps} callBack={callBack} local={locale}/>
          )
      }}
    </LocaleReceiver>
  )

}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/components/video-player/index.tsx